import { BaseEntity, EntityDateInfo, IdType } from './common';
import { PermissionCode, PermissionTemplateCode } from './permission';

export enum UserStatus {
  ENABLED = 'Enabled',
  LOCKED = 'Locked',
}

export enum UserActions {
  ENABLE = 'Enable',
  LOCK = 'Lock',
  DELETE = 'Delete',
  UNGROUP = 'Ungroup',
}

export enum PermissionStatus {
  ALLOW = 'allow',
  DENY = 'deny',
}

export enum PermissionType {
  INDIVIDUAL = 'individual',
  GROUP = 'group',
}

export interface UserOld {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

export type UserPermission = { [key in PermissionCode]: PermissionStatus };

export interface UserDto {
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  prefixId: IdType | null;
  suffixId: IdType | null;
  jobTitleId: IdType | null;
  email: string | null;
  birthDate: Date | null;
  mobilePhone: string | null;
  workPhone: string | null;
  status: UserStatus | null;
  isForcePasswordChange: boolean | null;
  siteIds: IdType[] | null;
  permissionTemplateCode: PermissionTemplateCode | null;
  permissions: UserPermission | null;
  groupId: IdType | null;
  organizationId?: IdType | null; // Post only in Control, Get All
}

export interface User extends UserDto, BaseEntity, EntityDateInfo {}

export interface UserListItem extends BaseEntity {
  userName: string;
  email: string;
  permissionTemplateCode: PermissionTemplateCode;
  permissionType: PermissionType;
  registrationDate: string;
  status: UserStatus;
  permissionsIsCustomized: boolean;
}

export type UserListResponse = {
  id: IdType;
  userName: string;
};
